import {
  createReceiptPreset as publicCreateReceiptPreset,
  getReceiptPreset as publicGetReceiptPreset,
  getDefaultReceiptPreset as publicGetDefaultReceiptPreset,
  updateReceiptPreset as publicUpdateReceiptPreset,
  setDefaultReceiptPreset as publicSetDefaultReceiptPreset,
  deleteReceiptPreset as publicDeleteReceiptPreset,
  listReceiptPresets as publicListReceiptPresets,
  updateExtendedFields as publicUpdateExtendedFields,
} from './receipts-presets-v1-receipt-preset-receipt-presets.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onReceiptPresetCreated as publicOnReceiptPresetCreated } from './receipts-presets-v1-receipt-preset-receipt-presets.public.js';
import { onReceiptPresetDeleted as publicOnReceiptPresetDeleted } from './receipts-presets-v1-receipt-preset-receipt-presets.public.js';
import { onReceiptPresetUpdated as publicOnReceiptPresetUpdated } from './receipts-presets-v1-receipt-preset-receipt-presets.public.js';

export const createReceiptPreset: MaybeContext<
  BuildRESTFunction<typeof publicCreateReceiptPreset> &
    typeof publicCreateReceiptPreset
> = /*#__PURE__*/ createRESTModule(publicCreateReceiptPreset);
export const getReceiptPreset: MaybeContext<
  BuildRESTFunction<typeof publicGetReceiptPreset> &
    typeof publicGetReceiptPreset
> = /*#__PURE__*/ createRESTModule(publicGetReceiptPreset);
export const getDefaultReceiptPreset: MaybeContext<
  BuildRESTFunction<typeof publicGetDefaultReceiptPreset> &
    typeof publicGetDefaultReceiptPreset
> = /*#__PURE__*/ createRESTModule(publicGetDefaultReceiptPreset);
export const updateReceiptPreset: MaybeContext<
  BuildRESTFunction<typeof publicUpdateReceiptPreset> &
    typeof publicUpdateReceiptPreset
> = /*#__PURE__*/ createRESTModule(publicUpdateReceiptPreset);
export const setDefaultReceiptPreset: MaybeContext<
  BuildRESTFunction<typeof publicSetDefaultReceiptPreset> &
    typeof publicSetDefaultReceiptPreset
> = /*#__PURE__*/ createRESTModule(publicSetDefaultReceiptPreset);
export const deleteReceiptPreset: MaybeContext<
  BuildRESTFunction<typeof publicDeleteReceiptPreset> &
    typeof publicDeleteReceiptPreset
> = /*#__PURE__*/ createRESTModule(publicDeleteReceiptPreset);
export const listReceiptPresets: MaybeContext<
  BuildRESTFunction<typeof publicListReceiptPresets> &
    typeof publicListReceiptPresets
> = /*#__PURE__*/ createRESTModule(publicListReceiptPresets);
export const updateExtendedFields: MaybeContext<
  BuildRESTFunction<typeof publicUpdateExtendedFields> &
    typeof publicUpdateExtendedFields
> = /*#__PURE__*/ createRESTModule(publicUpdateExtendedFields);
/**
 * Triggered when a receipt preset is created.
 */
export const onReceiptPresetCreated: BuildEventDefinition<
  typeof publicOnReceiptPresetCreated
> &
  typeof publicOnReceiptPresetCreated = createEventModule(
  publicOnReceiptPresetCreated
);
/**
 * Triggered when a receipt preset is deleted.
 */
export const onReceiptPresetDeleted: BuildEventDefinition<
  typeof publicOnReceiptPresetDeleted
> &
  typeof publicOnReceiptPresetDeleted = createEventModule(
  publicOnReceiptPresetDeleted
);
/**
 * Triggered when a receipt preset is updated.
 */
export const onReceiptPresetUpdated: BuildEventDefinition<
  typeof publicOnReceiptPresetUpdated
> &
  typeof publicOnReceiptPresetUpdated = createEventModule(
  publicOnReceiptPresetUpdated
);

export { WebhookIdentityType } from './receipts-presets-v1-receipt-preset-receipt-presets.universal.js';
export {
  ReceiptPreset,
  DisplaySettings,
  BusinessDisplayOptions,
  CustomerDisplayOptions,
  ItemsDisplayOption,
  TotalsDisplayOption,
  CustomFields,
  CustomField,
  FooterCustomField,
  DisplayValues,
  ExtendedFields,
  CreateReceiptPresetRequest,
  CreateReceiptPresetResponse,
  GetReceiptPresetRequest,
  GetReceiptPresetResponse,
  GetDefaultReceiptPresetRequest,
  GetDefaultReceiptPresetResponse,
  UpdateReceiptPresetRequest,
  UpdateReceiptPresetResponse,
  SetDefaultReceiptPresetRequest,
  SetDefaultReceiptPresetResponse,
  DeleteReceiptPresetRequest,
  DeleteReceiptPresetResponse,
  ListReceiptPresetsRequest,
  ListReceiptPresetsResponse,
  UpdateExtendedFieldsRequest,
  UpdateExtendedFieldsResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  ReceiptPresetCreatedEnvelope,
  ReceiptPresetDeletedEnvelope,
  ReceiptPresetUpdatedEnvelope,
  UpdateReceiptPreset,
  UpdateExtendedFieldsOptions,
} from './receipts-presets-v1-receipt-preset-receipt-presets.universal.js';
export {
  WebhookIdentityTypeWithLiterals,
  CreateReceiptPresetApplicationErrors,
  GetDefaultReceiptPresetApplicationErrors,
  UpdateReceiptPresetApplicationErrors,
  DeleteReceiptPresetApplicationErrors,
  ListReceiptPresetsApplicationErrors,
} from './receipts-presets-v1-receipt-preset-receipt-presets.universal.js';
